import {
  EmailConfirmationFormValues,
  EmailConfirmationFormViolation,
} from 'types/emailConfirmationFormTypes';
import { stringIsEmpty } from './stringUtils';

export const createEmailConfirmationFormValues = (): EmailConfirmationFormValues => ({
  code: ['', '', '', '', '', ''],
  password: '',
});

export const validateEmailConfirmationWithCodeFormValues = (
  values: EmailConfirmationFormValues
): EmailConfirmationFormViolation[] => {
  const violations: EmailConfirmationFormViolation[] = [];

  const { code } = values;

  for (let [digitIndex, digitValue] of Array.from(code.entries())) {
    if (digitValue === '') {
      violations.push({
        name: 'DigitMissed',
        digitIndex,
      });
    }
  }

  return violations;
};

export const validateEmailConfirmationWithPasswordFormValues = (
  values: EmailConfirmationFormValues
): EmailConfirmationFormViolation[] => {
  const violations: EmailConfirmationFormViolation[] = [];

  const { password } = values;

  if (stringIsEmpty(password.trim())) {
    violations.push({
      name: 'PasswordMissed',
    });
  }

  return violations;
};
